import { HttpClient } from '#client/http/index'
import { CampaignBanner } from '#client/resources/index'
import { ApiResponse } from '#client/resources/types'

export const list = async ({ httpClient }: { httpClient: HttpClient }) => {
  const { data }: ApiResponse<CampaignBanner[]> = await httpClient.get(
    '/user/campaignBanners',
  )
  return data
}
